export default __webpack_public_path__ + "static/media/a068bf7ed23a487dd325fffabaaaf172.svg";